import {
  Identifiable,
  InvitedMember,
  inviteMembersError,
  Planzone,
  Resource,
  role,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function sendInvitation(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    member: InvitedMember,
    message: string,
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<Resource>>({
        endpoint: `/planzones/${uuid}/invite-user`,
        method: HttpMethods.POST,
        data: {
          email: member.email,
          lastName: member.lastName,
          firstName: member.firstName,
          language: member.language,
          roleUuid: member.role ? member.role.uuid : "",
          roleLabel: member.role ? member.role.name : "",
          message: message,
        },
      })
      .then((resource) => ({
        ...resource,
        role: {
          ...role,
          uuid: member.role ? member.role.uuid : "",
          name: member.role ? member.role.name : "",
        },
        tags: resource.tags
          ? resource.tags.map((tag) => {
              // @ts-ignore
              return typeof tag === "string" ? { name: tag } : tag;
            })
          : [],
      }))
      .catch((err) =>
        Promise.reject({
          ...inviteMembersError,
          ...mapError(err, {
            duplicatedInvitation: "duplicatedResourceName",
          }),
        }),
      );
}

export { sendInvitation };
